import React from 'react';
import { EditPage } from '@components/common';
import ResourceForm from '@components/common/forms/ResourceForm';

const ResourceEditPage = () => {
    const handleTransformData = (formData) => {
        // Don't extract metadata - let ResourceForm handle it
        // Transform form data for resource update
        return {
            ...formData,
            updated_at: new Date().toISOString()
        };
    };

    const handleTransformFetchedData = (data) => {
        // Transform fetched data for form consumption
        return {
            ...data,
            // Any necessary data transformations for editing
        };
    };

    return (
        <EditPage
            modelName="resources"
            FormComponent={ResourceForm}
            transformData={handleTransformData}
            transformFetchedData={handleTransformFetchedData}
            formProps={{
                showAdvancedOptions: true
            }}
        />
    );
};

export default ResourceEditPage;
